/* Wave2Wear 3D metal monogram hero. Builds an extruded chrome mesh from the
   inline SVG path and rotates it. Falls back to the static logo on
   no-WebGL / reduced-motion / error. Requires global THREE (three.min.js). */
(function () {
  function initHero(root) {
    try {
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      var canvas = root.querySelector('.w2w-hero3d__canvas');
      var svg = root.querySelector('.w2w-hero3d__fallback svg');
      if (!window.THREE || !canvas || !svg || reduce) { root.classList.add('is-static'); return; }

      var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      if (!gl) { root.classList.add('is-static'); return; }
      var THREE = window.THREE;

      var vb = (svg.getAttribute('viewBox') || '0 0 711 447').split(/\s+/).map(Number);
      var vbH = vb[3] || 447;
      var d = svg.querySelector('path').getAttribute('d');
      var pairs = [], re = /(-?\d*\.?\d+)[ ,]+(-?\d*\.?\d+)/g, m;
      while ((m = re.exec(d))) pairs.push([parseFloat(m[1]), vbH - parseFloat(m[2])]);
      if (pairs.length < 3) { root.classList.add('is-static'); return; }

      var shape = new THREE.Shape();
      pairs.forEach(function (p, i) { i ? shape.lineTo(p[0], p[1]) : shape.moveTo(p[0], p[1]); });
      shape.closePath();

      var depth = parseFloat(root.dataset.depth || '38');
      var geo = new THREE.ExtrudeGeometry(shape, {
        depth: depth, bevelEnabled: true, bevelThickness: depth * 0.18,
        bevelSize: 4, bevelSegments: 4, curveSegments: 6
      });
      geo.center();
      geo.computeBoundingSphere();
      var radius = geo.boundingSphere.radius;

      var renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, powerPreference: 'low-power' });
      renderer.setClearColor(0x000000, 0);
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.5));
      if (THREE.SRGBColorSpace) renderer.outputColorSpace = THREE.SRGBColorSpace;

      var scene = new THREE.Scene();

      // Studio-gradient environment -> gives the metal its reflections.
      // Used directly (no PMREM) to stay light & robust on heavy pages.
      var ec = document.createElement('canvas'); ec.width = 16; ec.height = 256;
      var ectx = ec.getContext('2d');
      var grd = ectx.createLinearGradient(0, 0, 0, 256);
      grd.addColorStop(0.00, '#ffffff');
      grd.addColorStop(0.45, '#ffffff');
      grd.addColorStop(0.60, '#eef1f4');
      grd.addColorStop(0.80, '#cdd1d6');
      grd.addColorStop(1.00, '#a7acb2');
      ectx.fillStyle = grd; ectx.fillRect(0, 0, 16, 256);
      var envTex = new THREE.CanvasTexture(ec);
      envTex.mapping = THREE.EquirectangularReflectionMapping;
      if (THREE.SRGBColorSpace) envTex.colorSpace = THREE.SRGBColorSpace;
      scene.environment = envTex;

      var color = parseInt((root.dataset.metal || 'dfe3e8').replace('#', ''), 16) || 0xdfe3e8;
      var mat = new THREE.MeshStandardMaterial({
        color: color, metalness: 0.9,
        roughness: parseFloat(root.dataset.roughness || '0.3'),
        envMapIntensity: 1.9
      });
      var mesh = new THREE.Mesh(geo, mat);
      mesh.rotation.x = -0.12;
      scene.add(mesh);

      scene.add(new THREE.AmbientLight(0xffffff, 0.7));
      var d1 = new THREE.DirectionalLight(0xffffff, 3.6); d1.position.set(2, 3, 4); scene.add(d1);
      var d2 = new THREE.DirectionalLight(0xdbe6ff, 1.5); d2.position.set(-4, -1, 2); scene.add(d2);
      var d3 = new THREE.DirectionalLight(0xfff3e0, 0.9); d3.position.set(0, -3, -3); scene.add(d3);

      var camera = new THREE.PerspectiveCamera(32, 1, 1, 8000);
      function resize() {
        var w = root.clientWidth || 1, h = root.clientHeight || 1;
        renderer.setSize(w, h, false);
        camera.aspect = w / h;
        var half = (camera.fov * Math.PI / 180) / 2;
        var fit = radius * 1.5;
        camera.position.z = Math.max(fit / Math.tan(half), fit / (Math.tan(half) * camera.aspect));
        camera.updateProjectionMatrix();
      }

      var speed = parseFloat(root.dataset.speed || '0.005');
      var running = false, raf;
      function tick() { mesh.rotation.y += speed; renderer.render(scene, camera); raf = requestAnimationFrame(tick); }
      function start() { if (!running) { running = true; tick(); } }
      function stop() { running = false; if (raf) cancelAnimationFrame(raf); }

      resize();
      window.addEventListener('resize', resize);
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es[0].isIntersecting ? start() : stop(); }, { threshold: 0.01 }).observe(root);
      } else { start(); }

      // If the GPU drops the context (heavy page), show the static logo instead of a frozen black mesh.
      canvas.addEventListener('webglcontextlost', function (e) { e.preventDefault(); stop(); root.classList.remove('is-3d'); root.classList.add('is-static'); }, false);

      root.classList.add('is-3d');
    } catch (e) {
      root.classList.add('is-static');
      if (window.console) console.warn('[w2w-hero-3d]', e && e.message);
    }
  }

  function boot() {
    var roots = document.querySelectorAll('.w2w-hero3d');
    for (var i = 0; i < roots.length; i++) initHero(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
